import { ALLOCATUS_CATEGORY, CustomProperties } from "./constants";

export const removeCategory = () => new Promise<void>((resolve, reject) => {
  const { item } = Office.context.mailbox;
  if (!item || !item.categories || !item.categories.removeAsync) {
    reject();
    return;
  }

  item.categories.removeAsync([ALLOCATUS_CATEGORY], result => {
    if (result.error) {
      console.error("Error removing category:", result.error);
      reject(result.error);
    } else {
      resolve()
    };
  });
})

export const removeProperties = () => new Promise<void>((resolve, reject) => {
  const { item } = Office.context.mailbox;
  if (!item || !item.loadCustomPropertiesAsync) {
    reject();
    return;
  }

  item.loadCustomPropertiesAsync(result => {
    if (result.error) reject(result.error);
    else if (!result.value) reject();
    else {
      result.value.remove(CustomProperties.TaskId);
      result.value.remove(CustomProperties.AppointmentId);
      result.value.saveAsync(result2 => {
        if (result2.error) reject(result2.error);
        else resolve();
      })
    }
  })
});

export const setCategory = () => new Promise<void>((resolve, reject) => {
  const { item } = Office.context.mailbox;
  if (!item || !item.categories || !item.categories.addAsync) {
    reject();
    return;
  }

  item.categories.addAsync([ALLOCATUS_CATEGORY], result => {
    if (result.error) {
      console.error("Error setting category:", result.error);
      reject(result.error);
    } else {
      resolve()
    };
  });
})

export const setProperties = (taskId: string, projectGuid: string, taskGuid: string, appointmentId: string) => new Promise<void>((resolve, reject) => {
  const { item } = Office.context.mailbox;
  if (!item || !item.loadCustomPropertiesAsync) {
    reject();
    return;
  }

  const linkToTask = `<a href="https://webapp.cloud.allocatus.com/Projects/Project/${projectGuid}?taskId=${taskGuid}#appId=[${appointmentId}]" target="_blank">Link to Task</a>`;

  item.body.getAsync(Office.CoercionType.Html, (result) => {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      const updatedBody = result.value + linkToTask;

      item.body.setAsync(updatedBody, { coercionType: Office.CoercionType.Html }, (setResult) => {
        if (setResult.status === Office.AsyncResultStatus.Succeeded) {
          resolve();
        } else {
          reject(setResult.error);
        }
      });
    } else {
      reject(result.error);
    }
  });

  item.loadCustomPropertiesAsync(result => {
    if (result.error) reject(result.error);
    else if (!result.value) reject();
    else {
      result.value.set(CustomProperties.TaskId, taskId);
      result.value.set(CustomProperties.AppointmentId, appointmentId);
      result.value.saveAsync(result2 => {
        if (result2.error) reject(result2.error);
        else resolve();
      })
    }
  })

});

export const save = () => new Promise<string>((resolve, reject) => {
  const { item } = Office.context.mailbox;
  if (!item || !item.saveAsync) {
    reject();
    return
  }

  item.saveAsync(result => {
    if (result.error) reject(result.error);
    else if (!result.value) reject();
    else resolve(result.value);
  });
});

export const getEventId = () => new Promise<string>(async (resolve, reject) => {
  const { item, convertToRestId } = Office.context.mailbox;
  if (!item || !item.saveAsync || !convertToRestId) {
    reject();
    return;
  }

  try {
    const id = await save();
    resolve(convertToRestId(id, Office.MailboxEnums.RestVersion.v1_0));
  } catch (e) {
    reject(e);
  }
})